/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum SamplingMethod {
    ACTIVE_LEARNING = 'ACTIVE_LEARNING',
    CORAL = 'CORAL',
    CORESET = 'CORESET',
    RANDOM = 'RANDOM'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const SamplingMethodValidatorShape = [
    'ACTIVE_LEARNING',
    'CORAL',
    'CORESET',
    'RANDOM'
];
export const SamplingMethodValidator = yup.mixed().oneOf(SamplingMethodValidatorShape);
export const SamplingMethodStringifyShapeProperties = {};
export const SamplingMethodStringifyShape: StringSchema = {
    title: 'SamplingMethod Stringifier',
    type: 'string'
};
export const SamplingMethodStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(SamplingMethodStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function SamplingMethodFromJSON(json: any): SamplingMethod {
    return SamplingMethodFromJSONTyped(json, false);
}
export function SamplingMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): SamplingMethod {
    return json as SamplingMethod;
}
export function SamplingMethodToJSON(value?: SamplingMethod | null): any {
    return value as any;
}
